var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1320",
    "data-name": "Group 1320",
    transform: "translate(-5829 -3174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1319",
    "data-name": "Group 1319"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1317",
    "data-name": "Group 1317"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_738",
    "data-name": "Path 738",
    d: "M5840,3184.867a4.292,4.292,0,1,1,4.292-4.292h0A4.3,4.3,0,0,1,5840,3184.867Zm0-6.737a2.445,2.445,0,1,0,2.445,2.445A2.448,2.448,0,0,0,5840,3178.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1318",
    "data-name": "Group 1318"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_739",
    "data-name": "Path 739",
    d: "M5846.063,3193.717a.924.924,0,0,1-.924-.924v-1.347a3.128,3.128,0,0,0-3.119-3.118h-4.041a3.127,3.127,0,0,0-3.118,3.119v1.346a.924.924,0,1,1-1.848,0v-1.347a4.979,4.979,0,0,1,4.965-4.966h4.043a4.98,4.98,0,0,1,4.966,4.966v1.347A.925.925,0,0,1,5846.063,3193.717Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_563",
    "data-name": "Rectangle 563",
    width: 22,
    height: 22,
    transform: "translate(5829 3174)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.2d36e17f452c249c31fc6527af6c3f49.svg";
export { ForwardRef as ReactComponent };